/*=========================================================================================
  File Name: index.js
  Namespace: vendors
  Description: Vuex Vendor Store
==========================================================================================*/
import {
  listVendors,
  getVendor
} from '@/services/vendors.service.js'

const state = {
  vendorList: {},
  count: 0,
  next: null,
  previous: null,
  results: []
}

const getters = {
  getVendors(state) {
    return Object.entries(state.vendorList).map(([key, value]) => {
      return {
        label: value.name.charAt(0).toUpperCase() + value.name.slice(1),
        value: key
      }
    })
  },
  getVendorsEntries(state) {
    return state.vendorList
  }
}

const mutations = {
  STORE_VENDOR_LIST(state, vendors) {
    state.vendorList = {
      ...state.vendorList,
      ...vendors.entries
    }
    state.count = vendors.count
    state.next = vendors.next
    state.previous = vendors.previous
    state.results = [...state.results, ...vendors.results]
  },
  RESET_VENDORS(state) {
    state.vendorList = {}
  }
}

const actions = {
  async getVendor({
    commit
  }, verdorId) {
    const response = await getVendor({
      verdorId: verdorId
    })
    if (response) {
      commit('STORE_VENDOR_LIST', response)
    }
    return response
  },
  async getAllVendors({
    commit, rootState
  }, params = {}) {
    params.company = rootState.app.company
    params.page_size = 256
    const response = await listVendors(params)
    if (response) {
      commit('STORE_VENDOR_LIST', response)
    }
    return response
  },
  resetCurrentVendors({
    commit
  }) {
    commit('RESET_VENDORS')
  }
}

export default {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}